import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';
import TexasPage from './components/texas/page/page';
import TexasButtons from './components/texas/buttons/buttons';
import TexasScratchTicketForm from './components/texas/form/form';
import WestVirginiaPage from './components/westVirginia/page/page';
import WestVirginiaButtons from './components/westVirginia/buttons/buttons';
import WestVirginiaScratchOffsForm from './components/westVirginia/form/form';
import MichiganPage from './components/michigan/page/page';
import MichiganButtons from './components/michigan/buttons/buttons';
import MichiganInstantsForm from './components/michigan/form/form';
import NewJerseyPage from './components/newJersey/page/page';
import NewJerseyButtons from './components/newJersey/buttons/buttons';
import NewJerseyScratchOffsForm from './components/newJersey/form/form';
import LanguageSelector from './components/general/LanguageSelector';
import DevLanding from './components/general/DevLanding';
import { LicenseInfo } from '@mui/x-license';

const muiXLicenseKey = process.env.REACT_APP_MUI_X_LICENSE_KEY;
LicenseInfo.setLicenseKey(muiXLicenseKey);

function App() {
  return (
    <Router>
      <LanguageSelector />
      {/*Implementing Routes for respective Path */}
      <Routes>
        <Route
          path='/'
          element={<DevLanding />}
        />

        {/** Michigan Routes */}
        <Route path='/mi' element={<MichiganPage />}>
          <Route index element={<MichiganButtons />} />
          <Route path='instants' element={<MichiganInstantsForm />} />
        </Route>

        {/** New Jersey Routes */}
        <Route path='/nj' element={<NewJerseyPage />}>
          <Route index element={<NewJerseyButtons />} />
          <Route path='scratch-offs' element={<NewJerseyScratchOffsForm />} />
        </Route>

        {/** New York Routes */}
        <Route path='/ny' element={<p>New York Page</p>}>
          <Route index element={<p>New York Buttons</p>} />
          <Route
            path='scratch-offs'
            element={<p>New York SCRATCH OFFS</p>}
          />
        </Route>

        {/** Texas Routes */}
        <Route path='/tx' element={<TexasPage />}>
          <Route index element={<TexasButtons />} />
          <Route path='scratch-tickets' element={<TexasScratchTicketForm />} />
        </Route>

        {/** West Virginia Routes */}
        <Route path='/wv' element={<WestVirginiaPage />}>
          <Route index element={<WestVirginiaButtons />} />
          <Route path='scratch-offs' element={<WestVirginiaScratchOffsForm />} />
        </Route>

        {/** Wisconsin Routes */}
        <Route path='/wi' element={<p>Wisconsin Page</p>}>
          <Route index element={<p>Wisconsin Buttons</p>} />
          <Route
            path='scratch-games'
            element={<p>Wisconsin SCRATCH GAMES</p>}
          />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
